module.exports = __webpack_public_path__ + "static/media/conejo.dc979f15.jpg";